import { useEffect } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
    if (window.fbq) {
      window.fbq("track", "PageView");
    }
  }, [location]);

  return null;
}

export default AnalyticsTracker;
